import moment from '@/app/shared/plugins/Moment'

const MONTHS_IN_YEAR = 12

const dateToIsoString = (date) => {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
}

export const getMonthOptions = () => {
  const currentYear = new Date().getFullYear()
  const currentMonth = new Date().getMonth()
  let targetYear = currentYear - 2
  const monthOptions = []
  for (targetYear; targetYear <= currentYear; targetYear++) {
    for (let month = 0; month < MONTHS_IN_YEAR; month++) {
      if (currentYear === targetYear && month > currentMonth) { break }
      const startDate = new Date(targetYear, month)
      const dateDescription = startDate.toLocaleString('default', { month: 'long', year: 'numeric' })
      monthOptions.push({
        text: dateDescription,
        value: {
          startDate: dateToIsoString(startDate),
          endDate: dateToIsoString(new Date(targetYear, month + 1, 0))
        }
      })
    }
  }
  return monthOptions
}

export const getlastNYears = (years) => {
  const currentYear = new Date().getFullYear()
  return Array.from({ length: years + 1 }, (v, k) => currentYear - k)
}

export const DAILY_SALES_CATEGORY_FORMAT = 'YYYY MMM DD ddd'
export const SALES_TWO_RANGES_FORMAT = 'YYYYMMDD'
export const ACTIVATION_DETAIL_FORMAT = 'YYYY-MM-DD'
export const ACTIVATION_FORMAT = 'DD MMM YYYY'
export const MONTHNAME_YEAR_FORMAT = 'MMMM YYYY'

export class BaseDate {
  constructor (jsDate = new Date()) {
    this.moment = moment(jsDate)
  }

  get yesterday () {
    const yesterday = this.moment.clone().subtract(1, 'day').toDate()
    return new BaseDate(yesterday)
  }

  get tomorrow () {
    const tomorrow = this.moment.clone().add(1, 'day').toDate()
    return new BaseDate(tomorrow)
  }

  addDays (nDays) {
    const datePlusNDays = this.moment.clone().add(nDays, 'day').toDate()
    return new BaseDate(datePlusNDays)
  }

  get aWeekAgo () {
    const aWeekAgo = this.moment.clone().subtract(7, 'day')
    return new BaseDate(aWeekAgo)
  }

  get nextWeek () {
    const nextWeek = this.moment.clone().add(7, 'day')
    return new BaseDate(nextWeek)
  }

  get aYearAgo () {
    const aYearAgo = this.moment.clone().subtract(1, 'year')
    return new BaseDate(aYearAgo)
  }

  get toDate () {
    return this.moment.toDate()
  }

  get utcOffset () {
    return moment().utcOffset()
  }

  setYear (year) {
    const newSetValue = this.moment.set('year', year)
    return new BaseDate(newSetValue)
  }

  get toFirstDayOfTheMonthDate () {
    const firstDayOfTheMonth = this.moment.clone().startOf('month')
    return new BaseDate(firstDayOfTheMonth)
  }

  get toLastDayOfTheMonthDate () {
    const lastDayOfTheMonth = this.moment.clone().endOf('month')
    return new BaseDate(lastDayOfTheMonth)
  }

  get toMs () {
    return this.moment.valueOf()
  }

  static parse (stringDate, format) {
    const parsedDate = moment(stringDate, format).toDate()
    return new BaseDate(parsedDate)
  }

  static get months () {
    return moment.months()
  }

  get toSalesTwoRangesFormat () {
    return moment(this.moment).format(SALES_TWO_RANGES_FORMAT)
  }

  get toDailySalesFormat () {
    return moment(this.moment).format(DAILY_SALES_CATEGORY_FORMAT)
  }

  get toActivationDetailFormat () {
    return moment(this.moment).format(ACTIVATION_DETAIL_FORMAT)
  }

  get toActivationFormat () {
    return moment(this.moment).format(ACTIVATION_FORMAT)
  }

  get toMonthNameYearFormat () {
    return moment(this.moment).format(MONTHNAME_YEAR_FORMAT)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/Date.js